module.exports = __webpack_public_path__ + "img/share-box-fill.91241430.svg";